import {z} from 'zod';

export const extractImagesFromZipRequestSchema = z.object({
  zipId: z.string().min(1),
  namespace: z.string().optional(),
  maxImages: z.number().int().min(1).max(50).optional(),
});

export type ExtractImagesFromZipRequest = z.infer<typeof extractImagesFromZipRequestSchema>;
